// @flow

import schema from 'docs/markdoc/schema';

export const getMarkdocElementSchema = (key: string) => {
  // Markdoc tags are the regular custom tags like {% aside %} and
  // nodes are extensions of Markdown native components, like code fences or
  // lists.
  const components = {
    ...schema.tags,
    ...schema.nodes,
  };

  const tag = components[key] || {};

  // Since we are passing over the attribute types using SSR which are defined
  // as Javascript constants like "String" and "Number", we need to serialize them,
  // since on React hydration they will turn to undefined.
  const tagAttributes = tag.attributes || {};
  const attributesWithSerializedTypes = Object.entries(tagAttributes).reduce(
    (attributes, [attribute, attributeConfigRaw]) => {
      const attributeConfig = (attributeConfigRaw: any);
      attributes[attribute] = {
        ...attributeConfig,
        type: attributeConfig.type ? attributeConfig.type.name : 'Unknown',
      };
      return attributes;
    },
    {},
  );

  return {...tag, attributes: attributesWithSerializedTypes};
};
